import axiosInstance from "./axiosConfig";

export const searchStudent = async (fullName: string, birthday: string) => {
  const response = await axiosInstance.post(`/student/search`, {
    fullName: fullName.trim().replace(/\s+/g, " "),
    birthday: birthday,
  });
  return response.data;
};
